const r = {
  styleOverrides: {
    valueLabel: ({ theme: a }) => ({
      borderRadius: a.shape.borderRadius * 0.5,
      backgroundColor: a.palette.secondary.main,
      "& .MuiSlider-valueLabelLabel": {
        ...a.typography.subtitle2,
        color: a.palette.primary.contrastText
      }
    })
  }
};
export {
  r as default
};
